import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

const Login = () => {

    let navigate = useNavigate();

    const [user, setUser] = useState({ email: '', password: '' })

    const handleChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value });
    }

    const submitForm = (e) => {
        e.preventDefault();
        const sendData = {
            email: user.email,
            password: user.password
        }

        console.log(sendData);

        axios.post('https://react-apis.dotlocalhost.com/login.php', sendData).then((result) => {
            if (result.data.Status === '200') {
                window.localStorage.setItem('email', result.data.email)
                window.localStorage.setItem('userName', result.data.first_name + ' ' + result.data.last_name)
                navigate('/dashboard');
            } else {
                alert('Invalid User');
            }
        })

    }

    return (
        <div className="main-box">

            <form onSubmit={submitForm}>

                <div className="row">
                    <div className="col-md-12 text-center logintext">
                        <h2>Login Page</h2>
                    </div>
                </div>

                <div data-mdb-input-init className="form-outline mb-4">    
                    <label className="form-label" for="form2Example1">Email address</label>
                    <input className="form-control" id="form2Example1" type="email" name="email" onChange={handleChange} value={user.email} />
                </div>

                <div data-mdb-input-init className="form-outline mb-4">
                    <label className="form-label" for="form2Example2">Password</label>
                    <input id="form2Example2" className="form-control" type="password" name="password" onChange={handleChange} value={user.password} />
                </div>

                <div className="row mb-4">
                    <div className="col d-flex justify-content-center">

                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" value="" id="form2Example31" checked />
                        <label className="form-check-label" for="form2Example31"> Remember me </label>
                    </div>
                    </div>

                    <div className="col">

                    <a href="#!">Forgot password?</a>
                    </div>
                </div>

                <button data-mdb-button-init data-mdb-ripple-init className="btn btn-primary btn-block mb-4" type="submit" name="submit">Sign in</button>

            </form>

        </div>
    )
}

export default Login;